module.exports = __webpack_public_path__ + "media/available_homes.0580654b.mp4";